import classesCell from './BodyCell.module.css'
import CheckboxCell from "../../common/interactive/CheckboxCell"

function buildCheckCellIdentifier(itemInfo, caseData) {
    if (itemInfo?.group === 'liability' && itemInfo?.label === 'limits_confirmed_with_carrier') {
        return {
            type: 'case_liability',
            field: 'limits_confirmed_with_carrier',
            type_id: caseData?.liability?.id ?? null,
            folder: 'liabilities',
            permissionType: 'liability_confirmed_with_carrier',
        }
    }

    return {
        type: itemInfo?.group === 'selfpay' ? 'case_selfpay' : itemInfo?.group === 'case' ? 'case' : itemInfo?.group,
        field: itemInfo?.label,
        type_id: null,
        folder: null,
    }
}

export default function CheckCell({checked, isDisabled, action, itemInfo, caseData}) {
    const identifier = buildCheckCellIdentifier(itemInfo, caseData)
    const missingLiabilityTarget =
        identifier.type === 'case_liability' && !identifier.type_id

    return <div className={`${classesCell.body_cell}`}>
        <CheckboxCell
            isDisabled={Boolean(isDisabled || missingLiabilityTarget)}
            checked={checked}
            action={action}
            identifier={identifier}
        />
    </div>
}
